// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__fbCkn","modOpen":"dropdown_modOpen__S4qjA","dropdownIcon":"dropdown_dropdownIcon__YVRa3","modCaretUp":"dropdown_modCaretUp__t8DD-"};